// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify from 'bemify-js';

import { TruncatedText } from '@zapier/common-components';

import Avatar from 'web-ssr/app/common/components/Avatar';
import 'web-ssr/app/common/components/AccountInfo/AccountInfo.scss';

const bem = bemify('account-info');

type Props = {
  accountId: number,
  meta?: string,
  title?: string,
  hideDetails?: boolean,
};

const AccountInfo = ({ accountId, meta, title, hideDetails }: Props) => {
  const metaNode =
    hideDetails === true || !meta ? null : (
      <span className={bem('__meta')}>
        <TruncatedText isBlock={true}>{meta}</TruncatedText>
      </span>
    );

  const details =
    hideDetails === true || (!meta && !title) ? null : (
      <div className={bem('__details')}>
        <span className={bem('__title')}>
          <TruncatedText isBlock={true}>{title}</TruncatedText>
        </span>
        {metaNode}
      </div>
    );

  return (
    <div className={bem('__content')}>
      <Avatar accountId={accountId} className={bem('__avatar')} />
      {details}
    </div>
  );
};

export default AccountInfo;
